export function showVideoContent(resource) {
  return (
    hasVideos(resource) &&
    !(
      hasWistiaVideoEmbed(resource) ||
      hasWistiaVideoIframe(resource) ||
      hasWistiaVideoShortCode(resource)
    )
  );
}

export const hasVideos = resource => (resource?.videos?.length ?? 0) > 0;

export const hasWistiaVideoShortCode = resource => /(\[wistia:)(.+?)\]/.test(resource.content);

export const hasWistiaVideoEmbed = resource =>
  /<script\s+[^>]*src\s*=\s*"https:\/\/fast.wistia.com\/embed/.test(resource?.content);

export const hasWistiaVideoIframe = resource =>
  /<iframe\s+[^>]*src\s*=\s*"https:\/\/fast.wistia.net\/embed/.test(resource?.content);

export const isUnitOrLessonPlan = resourceType =>
  ['lesson-plan', 'unit-plan', 'resource-pack'].includes(resourceType);

const resourcePaths = [
  '/teaching-resource/',
  '/unit-plan/',
  '/lesson-plan/',
  '/teaching-resource-pack/',
];
export const isResourcePath = path => {
  return resourcePaths.some(resourcePath => path.includes(resourcePath));
};
